export const environment = {
    siteId: 1,
    name: 'babylon',
    apiBaseUrl: 'https://remei-api-staging.clicktotravel.es/api',
    baseUrl: 'https://remei-api-staging.clicktotravel.es',
    token: '',
    email: 'front@clicktotravel.es',
    password: 'Xe7xV3YxaFR7yKGA-6i!',
    userPanel: 'admin',
    passPanel: '1234',
    booking_engine_enabled: true, // General switch for booking engine
    booking_engine_top_enabled: false, // Switch for booking engine button in top sliders
    booking_engine_extern: false,
    booking_button_engine_enabled: true, // Button booking engine
    openInNewWindow: false,
    trailingSlash: true,
    multipleMotorsModal: false,
    normalizeUrlsToLowercase: true,
    hotelRequestMotor: false, // Add request hotel motor
    minSizeMobileHeader: 768,
    menuComplexLinks: false,
    organizationName: 'Babylon',
    booking_engine_widget: false, // Use widget booking engine
    booking_engine_widget_dynamic: false, // widget static down
    dataBase: '../data/',
    sitesIndexFile: 'sites.json',
    fallbackUrl: 'https://staging-remei.clicktotravel.es/',
    hideUserCentrics: false, //Only for dev on true
};
